import { Text } from '@react-spectrum/s2';
import { style } from '@react-spectrum/s2/style' with { type: 'macro' };

import { cn } from '@/utils/cn.ts';

import { MessageRow } from './MessageRow.tsx';

export const UserMessage = ({ message }: { message: string }) => {
	return (
		<MessageRow justify="end">
			<div
				className={cn(
					'rounded-3xl',
					'px-6 py-4',
					'bg-gray-100',
					'text-(--text-primary)',
					// User messages are plain text, not markdown, so the newlines
					// typed with Shift+Enter only survive if whitespace is preserved.
					'whitespace-pre-wrap',
					// A flex item's `min-width: auto` floors it at its min-content width, so
					// one pasted URL made this bubble wider than the column and pushed the
					// row past the scroller. `break-words` is what splits a token with no
					// spaces in it. `AgentMessage` already carries the same three.
					'max-w-full min-w-0 break-words',
				)}
			>
				<Text
					styles={style({
						font: 'body',
						color: 'body',
						fontSize: 'body',
					})}
				>
					{message}
				</Text>
			</div>
		</MessageRow>
	);
};
